import styled from "styled-components";

export {
	SectionCard,
	SectionTitle,
} from "../../elements";

export const StatGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 10px;

	@media (min-width: 768px) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (min-width: 1200px) {
		grid-template-columns: repeat(3, 1fr);
	}
`;

export const StatCard = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
	padding: 14px 16px;
	border-radius: 14px;
	background: var(--input-bg-has-value);
	border: 1px solid rgba(110, 113, 145, 0.1);
	transition: border-color 0.2s ease, transform 0.2s ease;

	&:hover {
		border-color: rgba(99, 179, 237, 0.35);
		transform: translateY(-1px);
	}
`;

export const StatLabel = styled.div`
	color: var(--secondary-text-color);
	font-size: 11px;
	font-weight: 600;
	line-height: 16px;
	text-transform: uppercase;
	letter-spacing: 0.4px;
`;

export const StatValue = styled.div`
	color: var(--content-text-color);
	font-size: 18px;
	font-weight: 700;
	line-height: 26px;
`;

export const BalanceRows = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const BalanceRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 12px 14px;
	border-radius: 12px;
	background: var(--input-bg-has-value);
	border: 1px solid rgba(110, 113, 145, 0.08);
`;

export const BalanceLabel = styled.div`
	color: var(--secondary-text-color);
	font-size: 12px;
	font-weight: 600;
`;

export const BalanceValue = styled.div`
	color: var(--content-text-color);
	font-size: 15px;
	font-weight: 700;
`;

export const ChartContainer = styled.div`
	position: relative;
	width: 100%;
	height: ${({ $height }) => $height || 280}px;
	padding: 12px 10px 8px;
	border-radius: 16px;
	background: linear-gradient(180deg, rgba(110, 113, 145, 0.08) 0%, rgba(0, 0, 0, 0.12) 100%);
	border: 1px solid rgba(110, 113, 145, 0.14);
	overflow: hidden;

	&::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 1px;
		background: linear-gradient(
			90deg,
			transparent,
			rgba(99, 179, 237, 0.4),
			transparent
		);
	}
`;

export const ChartLabel = styled.div`
	margin-bottom: 8px;
	color: var(--secondary-text-color);
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.4px;
`;

export const ChartRow = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 14px;

	@media (min-width: 1024px) {
		grid-template-columns: ${({ $columns }) => $columns || "1fr 300px"};
		align-items: stretch;
	}
`;

export const ChartLegend = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-top: 10px;
`;

export const ChartLegendItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 10px;
	font-size: 12px;
`;

export const ChartLegendLabel = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 8px;
	color: var(--secondary-text-color);
	font-weight: 600;
`;

export const ChartLegendDot = styled.span`
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: ${({ $color }) => $color};
	flex-shrink: 0;
`;

export const ChartLegendValue = styled.span`
	color: var(--content-text-color);
	font-weight: 700;
	font-variant-numeric: tabular-nums;
`;
